/* unplugin-vue-components disabled */import { render } from "./SelfEvaluation.vue?vue&type=template&id=edb73526"
import script from "./SelfEvaluation.vue?vue&type=script&lang=js"
export * from "./SelfEvaluation.vue?vue&type=script&lang=js"

import "./SelfEvaluation.vue?vue&type=style&index=0&id=edb73526&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__